
import React, { useState } from 'react'
import { Carousel } from 'react-bootstrap'
import './Home.css'
import Testmonials from './Testmonials'
import CountUp from 'react-countup';
import { useInView } from 'react-intersection-observer';
import Card2 from './Card2';
import OurDoctors from './OurDoctors';
import FooterSection from './FooterSection';



const Home = () => {
  const { ref, inView } = useInView({
    triggerOnce: false,   // once matrame run avvali
  });
  return (
    <>

      <div className='p-0 TopMargin'>
        <Carousel className=" homeclass" variant='dark' controls={false} pause={false} >
          <Carousel.Item >
            <img
              className="d-block w-100"
              src="./slide4.jpeg"
              alt="First slide"
            />
            <Carousel.Caption className='carousel_container container '>
              <h6 className="doctor_name" >Dr.Garlapati Siva Srikar</h6>
              <p className="paragraph_carousel">Over 10+ years of Excellence </p >
              <p className="paragraph_carousel">in Orthopedic & Joint Replacement Surgery</p>
              <a href='/Contact'><button className='btn'>BOOK APPOINTMENT</button></a>
            </Carousel.Caption>

          </Carousel.Item>
          <Carousel.Item>
            <img
              className="d-block w-100"
              src="./slide22.jpeg"
              alt="Second slide"
            />
            <Carousel.Caption className='carousel_container container'>
              <h6 className="doctor_specialist" ><span>Our</span> Joint Replacement<br></br>
                Program <span>is with you<br></br>
                  at Every Step</span></h6>
              <p className='doctor_specialist_paragragh'>Seamless Care that follows you through Diagnosis, Surgery & Rehabilitation</p>
              <p className='doctor_specialist_paragragh'>Comprehensive care from Diagnosis to the point of Recovery Post Surgery</p>
              <a href='/Contact'><button className='btn'>BOOK APPOINTMENT</button></a>
            </Carousel.Caption>

          </Carousel.Item>
          <Carousel.Item>
            <img
              className="d-block w-100"
              src="./download.webp"
              alt="Third slide"
            />
            <Carousel.Caption className='carousel_container container'>
              <h6 className="doctor_specialist" >Best Orthopaedic Doctor<br></br>
                <span>in Guntur</span></h6>
              <div className='tick_marks'>
                <p className='doctor_specialist_paragragh'>Comprehensive Care</p>
                <p className='doctor_specialist_paragragh'>Multidisciplinary Team</p>
                <p className='doctor_specialist_paragragh'>Advanced Surgical Treatments</p>
              </div>
              <a href='/Contact'><button className='btn'>BOOK APPOINTMENT</button></a>
            </Carousel.Caption>

          </Carousel.Item>
        </Carousel>
      </div>

      {/* // reviews row Testmonials*/}


      <div className='custom-container testmonials_block'>
        <div className='row'>
          <div className='col-md-9'>
            <Testmonials />
          </div>
          <div className='col-md-3 Google_Review_icon' >
            <img src='G-reviews-icons.webp' alt='Google Image'></img>
          </div>
        </div>
      </div>

      {/* Experience count */}

      <div className='custom-container doctor_excellence'>
        <div className='row'>
          <div className='col-md-5'>
            <div className='row experience_row'>
              <div className='col-md-3'>
                <div className='circle mt-3'>
                  <p className='experience'>10</p>
                </div>
              </div>
              <div className='col-md-9 mt-4' style={{ color: 'grey', fontWeight: 'bold' }}>
                <h2>Years Excellence in Orthopedics</h2>
              </div>
            </div>
          </div>

          <div className='col-md-7 mt-4'>
            <div className="row" >
              <div ref={ref} className="row">
                <div className="col-md-4">
                  <h1 style={{ color: 'grey', fontWeight: 'bold' }}>
                    {inView && <CountUp start={0} end={1500} duration={2} />}
                    +
                  </h1>
                  <p style={{ color: 'grey', fontWeight: 'bold' }}>Happy Patients</p>
                </div>
                <div className="col-md-4">
                  <h1 style={{ color: 'grey', fontWeight: 'bold' }}>
                    {inView && <CountUp start={0} end={1000} duration={2} />}+
                  </h1>
                  <p style={{ color: 'grey', fontWeight: 'bold' }}>Ortho Surgeries</p>
                </div>
                <div className="col-md-4">
                  <h1 style={{ color: 'grey', fontWeight: 'bold' }}>
                    {inView && <CountUp start={0} end={12} duration={2} />}
                  </h1>
                  <p style={{ color: 'grey', fontWeight: 'bold' }}>Awards</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* About Doctor Content */}

      <div className='custom-container about'>
        <div className='row'>
          <div className='col-md-6'>
            <img src='Doc-about-img.png' alt='' style={{ width: '100%' }}></img>
          </div>
          <div className='col-md-6 doctor_qualifications'>
            <h5 style={{ color: '#0899ff' }}>ABOUT</h5>
            <h1 style={{ color: '#575454', fontWeight: 'bold' }}>Best Orthopedic Doctor in Guntur</h1>
            {/* <p>Dr. Garlapati Siva Srikar is a highly skilled and dedicated Orthopaedic Surgeon specializing in Trauma, Joint Replacement, Arthroscopy, and Sports Medicine. With a strong academic background and extensive clinical experience, he is committed to delivering advanced and patient-centered orthopaedic care.</p>
            <p>He completed his MBBS from Katuri Medical College, followed by MS in Orthopaedics from NRI Academy of Sciences, affiliated with Dr. NTR University of Health Sciences. Further enhancing his expertise, he pursued prestigious fellowships in Trauma, Joint Replacement, and Arthroscopy & Sports Medicine from reputed institutions across India.</p>
            <p>Dr. Srikar currently serves as a Consultant Orthopaedic Trauma, Arthroscopy, and Joint Replacement Surgeon at Sree Prathima Super Speciality Hospitals, Guntur. He has vast experience in managing complex trauma cases, joint replacement surgeries, and minimally invasive arthroscopic procedures.</p>
            <p>His surgical expertise includes fracture management, interlocking nailing, joint replacements (hip and knee), arthroscopic ligament reconstructions, tendon repairs, and sports injury treatments. He is also well-trained in advanced procedures such as Ilizarov techniques, complex trauma reconstruction, and minimally invasive orthopaedic surgeries.</p>
            <p>Dr. Srikar has actively contributed to medical research with publications in reputed journals and presentations at national conferences such as IOACON and OSSAPCON. He has also received recognition for his academic excellence, including winning the OSSAP PG Quiz.</p>
            <p>He is a life member of several professional organizations including the Orthopaedic Surgeons Society of Andhra Pradesh (OSSAP), Indian Medical Association (IMA), and Indian Academy of Orthopaedic Surgeons (IAOS).</p>
            <p>Known for his compassionate approach and commitment to excellence, Dr. Srikar continuously updates his knowledge and skills to provide the best possible outcomes for his patients.</p> */}
            <p style={{ color: '#575454', fontWeight: 'normal',textAlign:'justify' }}>Dr. Garlapati Siva Srikar is a Consultant Orthopedic Surgeon specializing in Trauma, Joint Replacement, Arthroscopy, and Sports Medicine. He completed his MBBS and MS Orthopaedics from reputed institutions and further pursued fellowships in Trauma, Joint Replacement, and Arthroscopy.</p>
            <p style={{ color: '#575454', fontWeight: 'normal',textAlign:'justify' }}>Currently practicing at Sree Prathima Super Speciality Hospitals, Guntur, he has extensive experience in managing fractures, joint replacements, and sports injuries using advanced surgical techniques.</p>
            <p style={{ color: '#575454', fontWeight: 'normal',textAlign:'justify' }}>He is an active member of OSSAP, IMA, and IAOS, and has contributed to research and national conferences. Dr. Srikar is known for his patient-focused care and commitment to excellence in orthopaedics.</p>
            <div className='d-flex align-items-center doctor_sub_content'>
              <img src='Doc-circle-img.png' alt='' className='doc-img'></img>
              <div className='ms-5 doctor-info'>
                <h6 style={{ color: '#0899ff' }}>Dr. Garlapati Siva Srikar</h6>
                <p>MBBS, MS (Orthopaedics)</p>
                <p>Chief Consultant Orthopaedic & Joint Replacement Surgeon</p>
                <p>Trained in Trauma</p>
                <p>Joint Replacement & Arthroscopy</p>
              </div>
            </div>
          </div>
        </div>
      </div>


      {/* our services block */}

      <div className='custom-container service_block'>
        <h1 style={{ color: '#ff8a00' }}>Our Services</h1>
        <p>We offer comprehensive medical & surgical treatments for a wide range of orthopedic conditions under one roof. Our team of
          orthopedic surgeons are available round the clock to ensure timely treatment for all orthopedic emergencies.</p>
      </div>
      <div className='custom-container service_block'>
        <Card2 />
      </div>

      <div className='custom-container service_block'>
        <OurDoctors />
      </div>

    </>
  )
}

export default Home
